/**
 * index.ts - FMwvTool Skins
 * 
 * Export all skins and registration utilities.
 * Now uses complete light/dark/auto skins from Skinnr package.
 */

import { fmwvtoolDefaultSkin } from './fmwvtool-default.skin';
import { fmwvtoolDefault, fmwvtoolDefaultLight, fmwvtoolDefaultDark } from '../../../../packages/skinnr/src/skins/fmwvtool';

// Export all skins (legacy + new complete skins)
export const fmwvtoolSkins = [
  fmwvtoolDefaultSkin,      // Legacy skin (for backward compatibility)
  fmwvtoolDefault,          // New auto-switching skin
  fmwvtoolDefaultLight,     // New complete light skin
  fmwvtoolDefaultDark,      // New complete dark skin
];

// Export individual skins
export { fmwvtoolDefaultSkin };
export { fmwvtoolDefault, fmwvtoolDefaultLight, fmwvtoolDefaultDark };

/**
 * Register FMwvTool skins with a Skinnr instance
 */
export const registerFMwvToolSkins = (skinnr: any) => {
  fmwvtoolSkins.forEach(skin => {
    skinnr.registerSkin(skin.id, skin);
  });
  
  console.log('[FMwvTool Skins] Registered:', fmwvtoolSkins.map(s => s.id));
};

export default fmwvtoolSkins;
